































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import SellsSelector from '@/components/selectors/Sells/SellsSelector.vue';
import SellsDetailSelector from '@/components/selectors/Sells/SellsDetailSelector.vue';
import SellsDetailPalletSelector from '@/components/selectors/Sells/SellsDetailPalletSelector.vue';
import ISells from '@/store/models/ISells';
import ISellsDetailPallets from '@/store/models/ISellsDetailPallets';
import ICompany from '@/store/models/ICompany';
import SellsApi from '../store/api/SellsApi';
import SellsDetailApi from '../store/api/SellsDetailApi';
import SellsDetailPalletsApi from '../store/api/SellsDetailPalletsApi';
import CompanyApi from '../store/api/CompanyApi';
import CustomerApi from '../store/api/CustomerApi';
import IAuthentication from '@/store/models/IAuthentication';
import IRolePermission from '@/store/models/IRolePermission';
import ICustomer from '@/store/models/ICustomer';
import ListStatusSellApi from '@/store/api/ListStatusSellApi';
import IListStatusSell from '@/store/models/IListStatusSell';
import IWarehouse from '@/store/models/IWarehouse';
import WarehouseApi from '../store/api/WarehouseApi';
import SettingsCompanyApi from '@/store/api/SettingsCompanyApi';
import INotification from '@/store/models/INotification';
import NotificationApi from '@/store/api/NotificationApi';
import StockApi from '@/store/api/StockApi';
import IStock from '@/store/models/IStock';
import ISellsDetail from '@/store/models/ISellsDetail';
import ISellProduct from '@/store/models/ISellProduct';
import { SettingsCompany } from '@/components/shared/SettingsCompany';
import ICompaniesLicence from '@/store/models/ICompaniesLicence';
import CompanyLicensesApi from '@/store/api/CompaniesLicensesApi';
import { EMPTY_GUID } from '@/config/constants';

@Component({
    components: {
        Snackbar,
        SellsSelector,
        SellsDetailSelector,
        SellsDetailPalletSelector
    }
})
export default class Sells extends Vue {
    SellList : ISells[] = [];
    SellDetailList: ISellsDetail[] = [];
    SellDetailPalletsList: ISellsDetailPallets[] = [];
    sellsApi : SellsApi;
    sellsDetailApi : SellsDetailApi;
    sellsDetailPalletsApi : SellsDetailPalletsApi;
    selectedSell : ISells | null = null;
    stockApi : StockApi;
    idSell : string = "";
    permissions : IRolePermission[] = [];
    companyId : string = "";
    customerApi : CustomerApi;
    companyApi : CompanyApi;
    CompanyList : ICompany[] = [];
    CustomerList : ICustomer[] = [];
    StockList : IStock[] = [];
    CustomerStockList : IStock[] = [];
    listStatusSellApi : ListStatusSellApi;
    StatusSellList : IListStatusSell[] = [];
    activeTab : number = 0;
    CompanySourceName : string = "";
    CompanyDestinationName : string = "";
    WarehouseList : IWarehouse[] = [];
    warehouseApi: WarehouseApi;
    enableTabsItem: boolean = false;
    enableTabsItemSell : boolean = false;
    overlay: boolean = false;
    overlayDetail: boolean = false;
    overlayDetailPallets: boolean = false;
    settingsCompanyApi: SettingsCompanyApi;
    notificationApi : NotificationApi;
    userName : string = "";
    completedSells : boolean = false;
    InboundCodeList: IStock[] = [];
    stockListCustomerPalletsAmount: IStock[] = [];
    isStandAlone: boolean = false;
    scannerActive : boolean = false;
    companyLicensesApi: CompanyLicensesApi;
    constructor() {
        super();
        this.sellsApi = new SellsApi();
        this.companyApi = new CompanyApi();
        this.customerApi = new CustomerApi();
        this.sellsDetailApi = new SellsDetailApi();
        this.listStatusSellApi = new ListStatusSellApi();
        this.warehouseApi = new WarehouseApi();
        this.settingsCompanyApi = new SettingsCompanyApi("Inbounds");
        this.notificationApi = new NotificationApi();
        this.stockApi = new StockApi();
        this.sellsDetailPalletsApi = new SellsDetailPalletsApi();
        this.companyLicensesApi = new CompanyLicensesApi();
    }
    
    created() {
        this.overlay = true;
        this.getPermissions();
        this.getCompanies();
        this.getStatusSell();
        this.getCustomers();
        this.getSells();
        this.getWarehouses();
        this.overlay = false;
    }

    showOverlay() {
        this.overlay = true;
    }

    closeOverlay() {
        this.overlay = false;
    }

    get isSuperAdmin() {
        return this.companyId === EMPTY_GUID;
    }

    get SellCodeSelected() {
        if (this.selectedSell) {
            return "Sell " + this.selectedSell.inboundCodeDestination;
        } else {
            return "Sell";
        }
    }

    get filteredStockList() {
        if (this.selectedSell) {
            if (this.selectedSell.inboundCodeSource) {
                let result = this.StockList.filter(item => item.availableCasesFinal > 0).filter(item => item.codeInbounds === this.selectedSell!.inboundCodeSource);
                return result;
            }
        }
        const filtered = this.StockList.filter(item => item.availableCasesFinal > 0);
        return filtered;
    }

    get HasDetails() {
        if (this.SellDetailList) {
            if (this.SellDetailList.length > 0) {
                return true;
            }
        }
        return false;
    }

    async getStockPalletsAmount(item: IStock) {
        let index = this.WarehouseList.findIndex(i => i.name === item.warehouseName);
        if (index !== -1) {
            item.idWarehouse = this.WarehouseList[index].id;
            this.stockListCustomerPalletsAmount = await this.stockApi.GetStockPalletsAmount(item);
            this.stockListCustomerPalletsAmount.forEach(t => {
                t.warehouseName = item.warehouseName;
                t.goodName = item.goodName;
            });
        }
    }

    async getPermissions() {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.companyId = userFromStorage.idCompany;
        this.userName = userFromStorage.username;
        this.permissions.push(userFromStorage.rolePermissions.find(r => r.formName === "Sells"));
        let settingsCompany = SettingsCompany.Settings.StandAlone;
        let setting = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
        let licencesForms: ICompaniesLicence[] = [];
        licencesForms = await this.companyLicensesApi.GetLicenceByIdCompany(this.companyId);
        let hasLicenseScanner = licencesForms.some(license => license.formName.toLocaleLowerCase() === "scanner");
        if (setting.length > 0) {
            if (setting[0].value.toLocaleLowerCase() === "yes") {
                this.isStandAlone = true;
            }
        }
        if (!hasLicenseScanner) {
            this.scannerActive = true;
            settingsCompany = SettingsCompany.Settings.Scanner;
            setting = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
            if (setting.length > 0) {
                this.scannerActive = setting[0].value.toLocaleLowerCase() === "yes";
            }
        }
    }

    async showCompletedSells(completedSells : boolean) {
        this.showOverlay();
        if (completedSells) {
            this.SellList = [];
            this.SellList = await this.sellsApi.GetSellsCompleted(this.companyId);
        } else {
            if (this.completedSells) {
                this.SellList = [];
                this.getSells();
            }
        }
        this.completedSells = completedSells;
        this.closeOverlay();
    }

    async sellChanged(sell: ISells) {
        this.overlay = true;
        if (sell !== undefined && Object.keys(sell).length !== 0) {
            this.enableTabsItemSell = true;
            this.idSell = sell.id;
            this.CompanySourceName = sell.companySourceName;
            this.CompanyDestinationName = sell.companyDestinationName;
            this.enableTabsItem = true;
          
            this.getSellsDetail(sell.id);
            this.getSellsDetailPallets(sell.id);
            this.StockList = await this.stockApi.GetStockGroupByCustomer(sell.idCustomerSource);
        } else {
            this.enableTabsItemSell = false;
            this.idSell = "";
            this.activeTab = 0;
            this.enableTabsItem = false;
        }
        this.overlay = false;
    }

    async onChangeSelectedCustomerSource(selectedCustomer: ICustomer) {
        if (selectedCustomer !== undefined && Object.keys(selectedCustomer).length !== 0) {
            this.InboundCodeList = await this.stockApi.GetInboundsCodeInStockByCustomerId(selectedCustomer.id);
        }
    }

    async onClickAddGoods() {
        this.getStockCustomer(this.selectedSell!.idCustomerSource);
    }

    async getWarehouses() {
        this.WarehouseList = await this.warehouseApi.GetWarehousesShared(this.companyId);
    }

    async getStatusSell() {
        this.StatusSellList = await this.listStatusSellApi.GetListStatusSell();
    }

    async getSellsDetail(idSell: string) {
        this.SellDetailList = await this.sellsDetailApi.GetSellsDetail(idSell);
    }

    async getSellsDetailPallets(idSell: string) {
        this.SellDetailPalletsList = await this.sellsDetailPalletsApi.GetSellsDetailPallets(idSell);
    }

    async getCustomerStockFiltered() {
        if (this.selectedSell) {
            this.overlayDetailPallets = true;
            this.CustomerStockList = await this.stockApi.GetStockGroupByCustomer(this.selectedSell.idCustomerSource);
            this.overlayDetailPallets = false;
        }
    }

    async getSells() {
        this.SellList = await this.sellsApi.GetSells(this.companyId);
    }
    
    async getStockCustomer(idCustomerSource: string) {
        try {
            this.StockList = [];
            this.overlayDetail = true;

            if (!this.selectedSell) {
                this.overlayDetail = false;
                return;
            }

            const response = await this.stockApi.GetStockGroupByPalletsAndCustomerAndInboundCode(
                idCustomerSource,
                this.selectedSell.inboundCodeSource
            );
            type IStockExtended = IStock & {
                availableCasesReal: number;
                availableGoodsReal: number;
            };

            const filtered = response.reduce((acc: IStockExtended[], item) => {
                const availableCases = (item.availableCasesFinal != null) ? item.availableCasesFinal : 0;
                const soldCases = (item.sellCases != null) ? item.sellCases : 0;
                const goodsPerCase = (item.goodsPerCase != null) ? item.goodsPerCase : 0;

                const remainingCases = Math.max(availableCases - soldCases, 0);

                if (remainingCases > 0) {
                    const updatedItem: IStockExtended = Object.assign({}, item, {
                        availableCasesReal: remainingCases,
                        availableGoodsReal: remainingCases * goodsPerCase
                    });
                    acc.push(updatedItem);
                }

                return acc;
            }, []);

            this.StockList = filtered;

            // Asignamos IDs temporales
            this.StockList.forEach((item, index) => {
                item.id = 'pallet_' + (index + 1);
            });

            // 🔔 Si no hay material disponible, avisamos al usuario
            if (this.StockList.length === 0) {
                this.showMessageWarning("No available stock for this inbound.");
            }
        } catch (error) {
            console.error("Error loading stock:", error);
            this.showMessageError("Error loading stock from API.");
        } finally {
            // 🟢 Siempre cerrar el overlay, aunque falle o no haya datos
            this.overlayDetail = false;
        }
    }

    async getCompanies() {
        this.CompanyList = await this.companyApi.GetCompanies();
    }

    async getCustomers() {
        this.CustomerList = await this.customerApi.GetCustomers();
    }

    async setCompanies() {
        this.SellList.forEach((i) => {
            let companySource : ICompany = this.CompanyList.find(c => c.id === i.idCompanySource) as ICompany;
            i.companySourceName = companySource.name;
            let companyDestination : ICompany = this.CompanyList.find(c => c.id === i.idCompanyDestination) as ICompany;
            i.companyDestinationName = companyDestination.name;
        });
    }

    async saveNotification(editedSell: ISells, notificationText : string) {
        if (await this.canEditSell(editedSell) === true) {
            let idCompanyToNotify : string = "";
            if (this.companyId === editedSell.idCompanySource) {
                idCompanyToNotify = editedSell.idCompanyDestination;
            } else {
                idCompanyToNotify = editedSell.idCompanySource;
            }
            let notification : INotification = {
                subject: "Status sell " + editedSell.inboundCodeDestination + " changed to " + editedSell.statusName,
                body: notificationText,
                type: "SELL",
                identifier: editedSell.id,
                destinationCompany: idCompanyToNotify
            };
            await this.notificationApi.SaveNotification(notification);
            this.showMessageInfo("The notification has been successfully sent to all users of the " + editedSell.companySourceName + " company.");
        } else {
            this.showMessageWarning("Unable to change sell status to completed because there are incomplete sell details.");
        }
    }

    deleteSell (item: ISells) {
        confirm('Are you sure you want to delete this sell?') && this.deleteSellItem(item);
    }

    async deleteSellItem(sell: ISells) {
        let resultDeleteSellDetail : boolean = await this.sellsDetailApi.DeleteInboundDetailBySellId(sell.id);
        if (resultDeleteSellDetail === false) {
            const errors: string = this.sellsDetailApi.getModelError().join("; ");
            this.showMessageError(errors);
        } else {
            let resultDeleteSellDetailPallets : boolean = await this.sellsDetailPalletsApi.DeleteInboundDetailBySellId(sell.id);
            if (resultDeleteSellDetailPallets === false) {
                const errors: string = this.sellsDetailPalletsApi.getModelError().join("; ");
                this.showMessageError(errors);
            } else {
                this.SellDetailList = [];
                this.SellDetailPalletsList = [];
                let result: boolean = await this.sellsApi.DeleteSell(sell.id);
                if (result) {
                    const index = this.SellList.indexOf(sell);
                    this.SellList.splice(index, 1);
                    this.showMessageInfo(`The sell ${sell.inboundCodeDestination} has been successfully deleted`);
                } else {
                    const errors: string = this.sellsApi.getModelError().join("; ");
                    this.showMessageError(errors);
                }
            }
        }
    }

    async completeSell(editedSell: ISells) {
        const response = await this.sellsApi.CompleteSell(editedSell.id);
        if (response) {
            this.showMessageInfo(`The sell has been successfully completed`);
        } else {
            this.showMessageError(`The sell has not been successfully completed`);
        }
    }

    get StatusSellCompleted() {
        if (!this.StatusSellList || this.StatusSellList.length === 0) return "";
        const found = this.StatusSellList.find(s => (s.name || "").toLowerCase() === "completed");
        return found ? found.id : "";
    }

    async saveSell(sell: ISells) {
        this.overlay = true;
        if (!sell.inboundCodeDestination || sell.inboundCodeDestination.trim() === "") {
            const codeResult = await this.companyApi.GetNextCode(this.companyId, "Inbounds");
            if (Array.isArray(codeResult) && codeResult.length > 0 && codeResult[0].column1) {
                sell.inboundCodeDestination = codeResult[0].column1.toString();
            }
        }
        const id = await this.sellsApi.SaveSell(sell);
        if (id) {
            sell.id = id;
            this.SellList = [sell].concat(this.SellList);
            this.selectedSell = sell;
            this.showMessageInfo(`The sell ${sell.inboundCodeDestination} has been successfully saved`);
        } else {
            const errors: string = this.sellsApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
    }

    async editSell(
        sell: ISells,
        done?: (r: { success: boolean; sell?: ISells }) => void,
        notificationText?: string
    ) {
        try {
            this.showOverlay();

            const completedId = this.StatusSellCompleted;
            const isTryingToSetCompleted =
                ((sell.statusName || "").toLowerCase() === "completed") ||
                (completedId !== "" && sell.idListStatusSell === completedId);

            // ✅ VALIDAR ANTES DE GUARDAR
            if (isTryingToSetCompleted) {
                const can = await this.canEditSell(sell);
                if (!can) {
                    await this.getSells();
                    const original = this.SellList.find(s => s.id === sell.id);
                    if (original) this.selectedSell = original;

                    this.showMessageWarning("Unable to change sell status to completed because there are incomplete sell details.");

                    if (done) done({ success: false, sell: original });
                    return;
                }

                // sell.dateSell = new Date();
            }
            // ✅ Guardar
            const updated = await this.sellsApi.UpdateSell(sell);

            if (!updated) {
                const errors: string = this.sellsApi.getModelError().join("; ");
                this.showMessageError(errors || "Error updating sell.");
                if (done) done({ success: false });
                return;
            }

            // ✅ Refrescar y re-seleccionar
            await this.getSells();
            const reselect = this.SellList.find(s => s.id === sell.id);
            if (reselect) this.selectedSell = reselect;

            // ✅ SOLO AHORA (cuando ya está guardado) enviamos notificación si hay texto
            if (notificationText && notificationText.trim() !== "" && reselect) {
                let idCompanyToNotify: string = "";

                if (this.companyId === reselect.idCompanySource) {
                    idCompanyToNotify = reselect.idCompanyDestination;
                } else {
                    idCompanyToNotify = reselect.idCompanySource;
                }

                const notification: INotification = {
                    subject: "Status sell " + reselect.inboundCodeDestination + " changed to " + reselect.statusName,
                    body: notificationText,
                    type: "SELL",
                    identifier: reselect.id,
                    destinationCompany: idCompanyToNotify
                };

                await this.notificationApi.SaveNotification(notification);

                // (opcional) mensaje UI
                // this.showMessageInfo("The notification has been successfully sent to all users of the " + reselect.companySourceName + " company.");
            }
            this.showMessageInfo(`The sell ${sell.inboundCodeDestination} has been successfully updated`);
            this.editSellItem(sell);
            if (done) done({ success: true, sell: reselect || sell });
        } catch (error) {
            console.error("Error updating sell:", error);
            this.showMessageError("Error updating sell.");
            if (done) done({ success: false });
        } finally {
            this.closeOverlay();
        }
    }

    async editSellItem (editedSell: ISells) {
        if (await this.canEditSell(editedSell) === true) {
            this.showOverlay();
            if (editedSell.idListStatusSell === this.StatusSellCompleted) {
                const confirmed = confirm('Are you sure you want to completed this sell?');

                if (!confirmed) {
                    return;
                }

                await this.updateSellDetailsCasesFromPallets();
                await this.completeSell(editedSell);
            }
            await this.getSells();
            this.showMessageInfo(`The sell ${editedSell.inboundCodeDestination} has been successfully Completed`);
            this.closeOverlay();
        } else {
            this.showMessageWarning("Unable to change sell status to completed because there are incomplete sell details.");
        }
    }

    async updateSellDetailsCasesFromPallets() {
        for (const sellDetail of this.SellDetailList) {
            const relatedPallets = this.SellDetailPalletsList.filter(
                p => p.idSellDetail === sellDetail.id
            );

            const palletsAmount = relatedPallets.length;
            const totalCases = relatedPallets.reduce((sum, p) => sum + Number(p.totalCases || 0), 0);
            const casesAmountPallet = relatedPallets.length > 0 ? Number(relatedPallets[0].totalCases || 0) : 0;

            sellDetail.palletsAmount = palletsAmount;
            sellDetail.casesAmountPallet = casesAmountPallet;
            sellDetail.totalCases = totalCases;

            await this.sellsDetailApi.UpdateSellDetail(sellDetail);
        }
    }

    async canEditSell(editedSell : ISells) : Promise<boolean> {
        let canEdit: boolean = true;

        if (editedSell.statusName.toLowerCase() === 'completed') {
            if (this.SellDetailPalletsList.length > 0) {
                let palletIds = [...new Set(this.SellDetailPalletsList.map(s => s.idPallet))];
                const stock = await this.stockApi.GetStockByPalletIds(this.selectedSell!.id, editedSell.idCustomerSource);
                let pallets = stock.filter(s => palletIds.includes(s.idPallet));

                let totalCasesAdded = pallets.reduce((sum, item) => sum + Number(item.totalCases || 0), 0);
                let totalCasesSell = this.SellDetailList.reduce(
                    (sum, current) => sum + Number(current.totalCases || current.casesAmountPallet || 0),
                    0
                );

                if (totalCasesAdded === totalCasesSell) {
                    return canEdit;
                }
            }

            canEdit = false;
        }

        return canEdit;
    }

    deleteSellDetail (item: ISellsDetail) {
        confirm('Are you sure you want to delete this sell detail?') && this.deleteSellDetailItem(item);
    }

    async deleteSellDetailItem(sellDetail: ISellsDetail) {
        if (this.SellDetailList.length > 0) {
            let founded = this.SellDetailPalletsList.filter(s => s.idSellDetail === sellDetail.id);
            if (founded.length > 0) {
                this.showMessageWarning(`The sell detail has pallets added to it, in order to remove it first remove the pallets.`);
            } else {
                let result: boolean = await this.sellsDetailApi.DeleteSellDetail(sellDetail.id);
                if (result) {
                    const index = this.SellDetailList.indexOf(sellDetail);
                    this.SellDetailList.splice(index, 1);
                    this.showMessageInfo(`The sell detail ${sellDetail.goodName} has been successfully deleted`);
                } else {
                    const errors: string = this.sellsDetailApi.getModelError().join("; ");
                    this.showMessageError(errors);
                }
            }
        }
    }

    async saveSellDetail(stockItems: IStock[]) {
        this.overlayDetail = true;

        for (const item of stockItems) {
            const sellDetail = this.MapToSellDetail(item);
            const id = await this.sellsDetailApi.SaveSellDetail(sellDetail);
            
            if (id) {
                sellDetail.id = id;

                // Solo agregamos si no existe ya
                const exists = this.SellDetailList.some(sd =>
                    sd.idInbound === sellDetail.idInbound &&
                    sd.idGood === sellDetail.idGood
                );

                if (!exists) {
                    this.SellDetailList.unshift(sellDetail);
                }
            }
        }
        await this.getSellsDetail(this.selectedSell!.id);
        this.overlayDetail = false;
        this.showMessageInfo("The sell details have been successfully saved");
    }

    MapToSellDetail(item: IStock) : ISellsDetail {
        let sellDetail : ISellsDetail = {} as ISellsDetail;
        sellDetail.idSell = this.selectedSell!.id;
        sellDetail.goodsPerCase = item.goodsPerCase;
        sellDetail.inboundCode = item.codeInbounds;
        sellDetail.idInbound = item.idInbound;
        sellDetail.idGood = item.idGood;
        sellDetail.goodName = item.goodName;
        sellDetail.idListPallet = item.idListPallet;
        sellDetail.palletName = item.listPalletName;
        sellDetail.palletsAmount = 1;
        sellDetail.casesAmountPallet = item.availableCasesFinal;
        sellDetail.idInboundDeliveryNoteDetail = item.idInboundDeliveryNoteDetail;
        sellDetail.totalCases = item.availableCasesFinal;
        sellDetail.bestBeforeDate = item.bestBeforeDate;
        return sellDetail;
    }
    
    deleteSellDetailPallet(item: ISellsDetailPallets) {
        confirm('Are you sure you want to delete this sell detail?') && this.deleteSellDetailPalletItem(item);
    }

    async deleteSellDetailPalletItem(sellDetailPallet: ISellsDetailPallets) {
        let result: boolean = await this.sellsDetailPalletsApi.DeleteSellDetailPallets(sellDetailPallet.id);
        if (result) {
            const index = this.SellDetailPalletsList.indexOf(sellDetailPallet);
            this.SellDetailPalletsList.splice(index, 1);

            const sellDetailIndex = this.SellDetailList.findIndex(sd => sd.id === sellDetailPallet.idSellDetail);
            if (sellDetailIndex !== -1) {
                const currentPalletsAmount = this.SellDetailList[sellDetailIndex].palletsAmount || 0;
                this.SellDetailList[sellDetailIndex].palletsAmount = Math.max(currentPalletsAmount - 1, 0);
                await this.sellsDetailApi.UpdateSellDetail(this.SellDetailList[sellDetailIndex]);
            }

            this.showMessageInfo(`The sell detail pallets ${sellDetailPallet.idPallet} has been successfully deleted`);
        } else {
            const errors: string = this.sellsDetailApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
    }

    async saveSellDetailPallets(stockItems: IStock[], selectedSellProduct: ISellProduct) {
        this.overlay = true;

        try {
            const baseSellDetail = this.SellDetailList.find(sd => sd.id === selectedSellProduct.idSellDetail);

            if (!baseSellDetail) {
                this.showMessageError("Base sell detail not found.");
                return;
            }

            // Agrupar pallets seleccionados por nº de cajas
            const grouped = stockItems.reduce((acc: Record<string, IStock[]>, item) => {
                const key = String(item.totalCases || 0);
                if (!acc[key]) {
                    acc[key] = [];
                }
                acc[key].push(item);
                return acc;
            }, {});

            const groupKeys = Object.keys(grouped)
            .map(Number)
            .sort((a, b) => b - a); // opcional: mayor a menor

            let firstGroup = true;

            for (const casesPerPallet of groupKeys) {
                const pallets = grouped[String(casesPerPallet)];
                const palletsAmount = pallets.length;
                const totalCases = pallets.reduce((sum, p) => sum + Number(p.totalCases || 0), 0);

                let sellDetailId = "";

                if (firstGroup) {
                    baseSellDetail.casesAmountPallet = casesPerPallet;
                    baseSellDetail.palletsAmount = palletsAmount;
                    baseSellDetail.totalCases = totalCases;

                    await this.sellsDetailApi.UpdateSellDetail(baseSellDetail);
                    sellDetailId = baseSellDetail.id;
                    firstGroup = false;
                } else {
                    const newSellDetail: ISellsDetail = Object.assign({}, baseSellDetail, {
                        id: "",
                        casesAmountPallet: casesPerPallet,
                        palletsAmount: palletsAmount,
                        totalCases: totalCases
                    });

                    const newId = await this.sellsDetailApi.SaveSellDetail(newSellDetail);

                    if (!newId) {
                        const errors: string = this.sellsDetailApi.getModelError().join("; ");
                        this.showMessageError(errors || "Error creating grouped sell detail.");
                        return;
                    }

                    newSellDetail.id = newId;
                    sellDetailId = newId;
                }

                for (const item of pallets) {
                    const sellProductForSave: ISellProduct = Object.assign({}, selectedSellProduct, {
                        idSellDetail: sellDetailId
                    });

                    const sellDetailPallet = this.MapToSellDetailPallets(item, sellProductForSave);

                    const id = await this.sellsDetailPalletsApi.SaveSellDetailPallets(sellDetailPallet);

                    if (id) {
                        sellDetailPallet.id = id;
                    }
                }
            }

            await this.getSellsDetail(this.selectedSell!.id);
            await this.getSellsDetailPallets(this.selectedSell!.id);

            this.showMessageInfo("The sell detail pallets have been successfully saved and split by pallet cases.");
        } finally {
            this.overlay = false;
        }
    }

    MapToSellDetailPallets(item: IStock, selectedSellProduct: ISellProduct) : ISellsDetailPallets {
        let sellDetailPallet : ISellsDetailPallets = {} as ISellsDetailPallets;
        sellDetailPallet.idSell = this.selectedSell!.id;
        sellDetailPallet.idInboundDeliveryNoteDetail = item.idInboundDeliveryNoteDetail;
        sellDetailPallet.idPallet = item.idPallet;
        sellDetailPallet.idSellDetail = selectedSellProduct.idSellDetail;
        sellDetailPallet.location = item.location;
        sellDetailPallet.goodName = item.goodName;
        sellDetailPallet.location = item.location;
        sellDetailPallet.palletTypeName = item.listPalletName;
        sellDetailPallet.warehouseName = item.warehouseName;
        sellDetailPallet.totalCases = item.totalCases;
        sellDetailPallet.totalGoods = item.totalGoods;

        return sellDetailPallet;
    }
   
    resetSell() {
        this.selectedSell = null;
        this.SellDetailList = [];
        this.SellDetailPalletsList = [];
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
